import React, { useState, useEffect } from 'react';

const WORDS = ["Brand Makers", "Professionals", "Digital Experts"];
const TYPING_SPEED = 150;
const DELETING_SPEED = 75;
const PAUSE_DURATION = 2000;

function BrandMakers() {
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const [currentText, setCurrentText] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    let timer;
    const targetWord = WORDS[currentWordIndex];

    if (!isDeleting) {
      // Typing phase
      if (currentText.length < targetWord.length) {
        timer = setTimeout(() => {
          setCurrentText(targetWord.substring(0, currentText.length + 1));
        }, TYPING_SPEED);
      } else {
        // Pause at full word before deleting
        timer = setTimeout(() => {
          setIsDeleting(true);
        }, PAUSE_DURATION);
      }
    } else {
      // Deleting phase
      if (currentText.length > 0) {
        timer = setTimeout(() => {
          setCurrentText(targetWord.substring(0, currentText.length - 1));
        }, DELETING_SPEED);
      } else {
        // Move to next word
        setIsDeleting(false);
        setCurrentWordIndex((prevIndex) => (prevIndex + 1) % WORDS.length);
      }
    }

    return () => clearTimeout(timer);
  }, [currentText, isDeleting, currentWordIndex]);

  return (
    <section className="brand-makers-section">
      <div className="container brand-makers-container">
        {/* Left Column: Heading with Typewriter */}
        <div className="brand-makers-left">
          <h2 className="brand-makers-heading">
            We are <span className="typed-text">{currentText}</span>
            <span className="typewriter-cursor">|</span>
          </h2>
        </div>

        {/* Right Column: Paragraph Content */}
        <div className="brand-makers-right">
          <p className="brand-makers-desc">
            At Experts Communication, we help businesses shape their digital future with powerful business process outsourcing solutions, digital marketing, and result driven IT solutions. No matter if you're searching for top IT companies in Karachi or need a trusted partner to build your brand and increase revenue, we're here to make it happen. From scratch to implementation, we turn ideas into impact and businesses into brands.
          </p>
        </div>
      </div>
    </section>
  );
}

export default BrandMakers;
